import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';

const ParentsAppealSection = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#f9f9f9' }}>
      <Container maxWidth="xl">
        <Grid container spacing={4} alignItems="center">
          {/* Левая часть - декоративные элементы и персонаж */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: { xs: 350, sm: 450, md: 550 },
              }}
            >
              {/* Зеленый круг */}
              <Box
                sx={{
                  position: 'absolute',
                  top: '10%',
                  left: '5%',
                  width: { xs: 100, sm: 150, md: 200 },
                  height: { xs: 100, sm: 150, md: 200 },
                  borderRadius: '50%',
                  backgroundColor: 'rgba(129, 199, 132, 0.6)',
                  zIndex: 1,
                }}
              />

              {/* Зеленый прямоугольник */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: { xs: '50%', sm: '55%', md: '60%' },
                  height: { xs: '45%', sm: '50%', md: '60%' },
                  backgroundColor: '#81C784',
                  borderRadius: 2,
                  zIndex: 2,
                }}
              />

              {/* Персонаж с карандашом */}
              <Box
                component="img"
                src="/img/5178414.jpg"
                alt="Персонаж с карандашом"
                sx={{
                  position: 'relative',
                  zIndex: 3,
                  width: { xs: 200, sm: 280, md: 350 },
                  height: { xs: 280, sm: 390, md: 490 },
                  objectFit: 'contain',
                  borderRadius: 3,
                  backgroundColor: 'white',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                  p: 0,
                }}
              />

              {/* Декоративная картинка-значок */}
              <Box
                component="img"
                src="/img/pngwing.com.png"
                alt="Значок"
                sx={{
                  position: 'absolute',
                  top: '5%',
                  right: '5%',
                  width: { xs: 80, sm: 110, md: 140 },
                  height: { xs: 80, sm: 110, md: 140 },
                  zIndex: 4,
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.15))',
                }}
              />
            </Box>
          </Grid>

          {/* Правая часть - текст */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                backgroundColor: 'white',
                borderRadius: 4,
                boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  mb: 3,
                  fontWeight: 700,
                  color: '#1a1a1a',
                  fontSize: { xs: '1.75rem', md: '2.25rem' }
                }}
              >
                Уважаемые родители!
              </Typography>

              <Box sx={{ '& p': { mb: 2, lineHeight: 1.8, color: 'text.secondary' } }}>
                <Typography variant="body1">
                  Если у Вас возникли вопросы, связанные с воспитанием образованием, 
                  обучением, развитием и социализацией Вашего ребенка.
                </Typography>

                <Typography variant="body1">
                  Вы решили взять на воспитание ребенка, оставшегося без попечения родителей.
                </Typography>

                <Typography variant="body1">
                  Вам не хватает информации о своих правах, правах ребенка в сфере образования.
                </Typography>

                <Typography variant="body1">
                  Вы можете обратиться в Центр консультирования «Волшебная страна» (далее-Центр).
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                  Наши специалисты БЕСПЛАТНО окажут Вам психолого-педагогическую, 
                  методическую и консультационную помощь в соответствии с Вашими потребностями!
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ParentsAppealSection;
